import React from 'react';

import {
  CTA,
  Container,
  Text,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { ThemeProvider } from '@vw-marketing/us-components';

import { DiscardChangesCTAContainerStyled } from './styled';

export interface DiscardChangesViewProps {
  translationHandler: (key: string) => string;
  onDiscard: () => void;
  onKeepEditing: () => void;
}

export const DiscardChangesView = ({
  translationHandler,
  onDiscard,
  onKeepEditing,
}: DiscardChangesViewProps) => (
  <ThemeProvider theme="main">
    <Container
      gutter="static300"
      padding="grid001"
      wrap="always"
    >
      <Text bold appearance={TokenTextAppearance.headline300}>
        {translationHandler('accountSettings.edit.discard.title')}
      </Text>
      <Text>
        {translationHandler('accountSettings.edit.discard.description')}
      </Text>
      <DiscardChangesCTAContainerStyled>
        <CTA onClick={onDiscard} tag="button" emphasis="primary">
          {translationHandler('accountSettings.edit.discard.action.affirmative')}
        </CTA>
        <CTA onClick={onKeepEditing} tag="button" emphasis="secondary">
          {translationHandler('accountSettings.edit.discard.action.negative')}
        </CTA>
      </DiscardChangesCTAContainerStyled>
    </Container>
  </ThemeProvider>
);
